import React from 'react';
import { Badge, Group, Tooltip, Box } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { FormTitle } from './FormTitle';

function ConnectedDataIcon() {
  return (
    <Tooltip
      label="This section updates automatically from data connections with the provider"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Box
        style={{
          backgroundColor: 'var(--mantine-color-blue-1)',
          borderRadius: '12px',
          padding: '4px 6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'help',
          height: '22px',
          minWidth: '22px',
        }}
      >
        <IconLink size={14} style={{ color: 'var(--mantine-color-blue-6)' }} />
      </Box>
    </Tooltip>
  );
}

export function useConnectedDataIcon(isUpdatedAutomatically: boolean): React.ReactNode {
  return isUpdatedAutomatically ? <ConnectedDataIcon /> : undefined;
}

function ConnectedDataBadge() {
  return (
    <Tooltip
      label="Sections indicated with this icon update automatically from data connections with the provider"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Badge
        variant="light"
        color="blue"
        size="xl"
        leftSection={<IconLink size={16} />}
        style={{ cursor: 'help' }}
      >
        Connected data
      </Badge>
    </Tooltip>
  );
}

export function FormTitleWithConnectedDataBadge({
  title,
  showBadge,
}: {
  title: string;
  showBadge: boolean;
}) {
  return (
    <Group>
      <FormTitle title={title} />
      {showBadge && <ConnectedDataBadge />}
    </Group>
  );
}
